import { render, staticRenderFns } from "./AddFormationPage.vue?vue&type=template&id=abce7dc0"
import script from "./AddFormationPage.vue?vue&type=script&lang=js"
export * from "./AddFormationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports